import React, { useContext, useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import { ContextData } from "../../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../BaseURL";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";

function SpouseDetails({ formData }) {


  const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);

  const [formDatas, setFormDatas] = useState({
    first_name: "",
    middle_name:  "",
    surname: "",
    office_address:  "",
    phone_no_1:  "",
    phone_no_2: "",
    email:  "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDatas((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateField = (type, value) => {
    // Optional fields
    if (type === "middle_name") return true;

    // Email validation
    if (type === "email") {

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value.trim());

    }

    // Numeric-only fields with max 15 digits
    const numericFields = ["phone_no_1", "phone_no_2"];

    if (numericFields.includes(type)) {

      return /^\d{1,15}$/.test(value.trim());


    }

    // Default: must not be empty
    return value.trim() !== "";
  };

  const handleSubmit =async (type) => {

    if (!validateField(type, formDatas[type])) {
      
      SoundAlert("error");
      if (type === "email") {

        toast.error("Please enter a valid email address.");

      } else if (["phone_no_1", "phone_no_2"].includes(type)) {

        toast.error("Must be numbers only (max 15 digits).");

      } else {

        toast.error("Please fill in this field.");


      }
      return;
    }


    const response = await Putrequest("auth/update_spouse_details",{...formDatas,user_token:UserTokens})
       
                   
                       if(response.status){
    
                        SoundAlert("success")
                        toast.success(response.textStatus)
                        setReloadBioForms(!ReloadBioForms)
    
                          }
    
    
  };



  useEffect(()=>{
  
         setFormDatas({
            first_name: formData.spouse_details.first_name || "",
            middle_name: formData.spouse_details.middle_name || "",
            surname: formData.spouse_details.surname || "" ,
            office_address: formData.spouse_details.office_address || "" ,
            phone_no_1: formData.spouse_details.phone_no_1  || "",
            phone_no_2: formData.spouse_details.phone_no_2 || "",
            email: formData.spouse_details.email || "",
         })
  
  },[formData])



  return (
    <div className="pt-2 pb-2">
      {/* First Name */}
      <TextField
        label="First Name"
        name="first_name"
        value={formDatas.first_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("first_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Middle Name (Optional) */}
      <TextField
        label="Middle Name (Optional)"
        name="middle_name"
        value={formDatas.middle_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("middle_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Surname */}
      <TextField
        label="Surname"
        name="surname"
        value={formDatas.surname}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("surname")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Office Address */}
      <TextField
        label="Office Address"
        name="office_address"
        value={formDatas.office_address}
        onChange={handleChange}
        fullWidth
        margin="dense"
        multiline
        rows={3}
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("office_address")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Phone No. 1 */}
      <TextField
        label="Phone No. 1"
        name="phone_no_1"
        value={formDatas.phone_no_1}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("phone_no_1")}>
              Save
            </Button>
          )
        }}
      />

      {/* Phone No. 2 */}
      <TextField
        label="Phone No. 2"
        name="phone_no_2"
        value={formDatas.phone_no_2}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("phone_no_2")}>
              Save
            </Button>
          )
        }}
      />

      {/* Email */}
      <TextField
        label="Email"
        name="email"
        value={formDatas.email}
        onChange={handleChange}
        type="email"
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("email")}>
              Save
            </Button>
          ),
        }}
      />
    </div>
  );
}

export default SpouseDetails;
